import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';
import { route } from 'preact-router';

@observer
class RaceClassDuplicate extends Component {
    constructor(props) {
        super(props);
        const { raceClass = {} } = props;
        this.state = {
            title: raceClass.title ? `${raceClass.title} (kopi)` : '',
            saving: false,
            hasError: false,
        };
    }

    onTitleChange = e => {
        this.setState({ title: e.target.value });
    }

    duplicateRaceClass = async () => {
        const { raceClassId, callback = () => {} } = this.props;
        const { raceClassStore } = this.props.stores;
        const { title, saving } = this.state;
        if (saving || !title || !title.trim()) {
            return;
        }
        this.setState({ saving: true, hasError: false });
        const result = await raceClassStore.duplicateRaceClass(raceClassId, { title });
        if (result?.raceClass?.id) {
            callback();
            route(`/raceclass/${result.raceClass.id}/admin/edit`);
        } else {
            this.setState({ saving: false, hasError: true });
        }
    }

    render() {
        const { callback = () => {} } = this.props;
        const { title, saving, hasError } = this.state;

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-bottom: 120px;'>
                    <div class='px-4 pt-4'>
                        <h5>
                            <i class='fa-solid fa-copy me-2' />
                            <Text id='raceclass.duplicate-title'>Copy raceclass</Text>
                        </h5>

                        <div class='alert alert-info mt-3'>
                            <Text id='raceclass.duplicate-info'>
                                All settings, dates, fees and content are copied to a new
                                raceclass in the same race. Signups and results are not copied.
                            </Text>
                        </div>

                        <div class='mb-3'>
                            <label class='form-label' for='raceClassDuplicateTitle'>
                                <Text id='raceclass.duplicate-new-title'>Title of new raceclass</Text>
                            </label>
                            <input
                                id='raceClassDuplicateTitle'
                                type='text'
                                class='form-control'
                                value={title}
                                onInput={this.onTitleChange}
                            />
                        </div>

                        {hasError && <div class='alert alert-danger'>
                            <Text id='raceclass.duplicate-error'>Could not copy the raceclass. Please try again.</Text>
                        </div>}
                    </div>

                    <div class='fixed-bottom d-flex justify-content-center py-3 bg-body border-top'>
                        <button
                            type='button'
                            class='btn btn-secondary rounded-pill me-3'
                            onClick={() => callback()}
                        >
                            <Text id='raceclass.duplicate-cancel'>Cancel</Text>
                        </button>
                        <button
                            type='button'
                            class='btn btn-primary rounded-pill'
                            disabled={saving || !title}
                            onClick={this.duplicateRaceClass}
                        >
                            {saving ? <>
                                <span class='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true' />
                                <Text id='raceclass.duplicate-saving'>Copying...</Text>
                            </> : <>
                                <i class='fa-solid fa-copy me-2' />
                                <Text id='raceclass.duplicate'>Copy raceclass</Text>
                            </>}
                        </button>
                    </div>
                </div>
            </div>
        </>);
    }
}

export default RaceClassDuplicate;
